import React, { useEffect, useState } from "react";
import { Table } from "reactstrap";
import { array } from "prop-types";

import moment from "moment";

import { useDispatch, useSelector } from "react-redux";
import SingleClientReportEntriesTableRow from "./row";
import {
  clearSingleClientReportPdf,
  exportSingleClientReportPdf,
} from "../../../../actions";

import {
  singleClientReportPdfIsLoadingSelector,
  singleClientReportPdfSelector,
} from "../../../../selectors";

const SingleClientReportEntriesTable = ({
  singleClientReportEntries,
  organizationInfo,
}) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  const dispatch = useDispatch();
  const singleClientReportPdf = useSelector(singleClientReportPdfSelector);
  const isLoading = useSelector(singleClientReportPdfIsLoadingSelector);

  const [clientId, setClientId] = useState(null);

  const handleExportPdf = (id) => {
    dispatch(exportSingleClientReportPdf({ clientId: id }));
    setClientId(id);
  };

  const rows = singleClientReportEntries.map((entry) => (
    <SingleClientReportEntriesTableRow
      key={entry.id}
      entry={entry}
      apiUrl={apiUrl}
      handleExportPdf={handleExportPdf}
      loading={isLoading ? clientId : 0}
      organizationInfo={organizationInfo}
    />
  ));

  useEffect(() => {
    if (singleClientReportPdf.size > 0) {
      const url = URL.createObjectURL(singleClientReportPdf);

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      //   window.navigator.msSaveOrOpenBlob(url);
      //   return;
      // }

      const link = document.createElement("a");
      link.href = url;
      link.download = `single-client-report-${clientId}-${moment
        .utc()
        .local()
        .format("DD-MM-YYYY-HHmm")}.pdf`;
      link.click();
      setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(url);
      }, 100);

      // window.location.href(url, '_blank');
      dispatch(clearSingleClientReportPdf());
    }
  }, [singleClientReportPdf]);

  return (
    <Table className="single-client-report-entries-table">
      <thead className="thead-light">
        <tr>
          <th>Type of client</th>
          <th>Name</th>
          <th>EGN / Company number</th>
          <th>OfferId</th>
          <th>Status</th>
          <th>Risk</th>
          {organizationInfo &&
            organizationInfo.additionalOrganizationProperties &&
            organizationInfo.additionalOrganizationProperties.map((element) => {
              return <th>{element.name}</th>;
            })}
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
    </Table>
  );
};

SingleClientReportEntriesTable.propTypes = {
  singleClientReportEntries: array.isRequired,
};

export default SingleClientReportEntriesTable;



// WEBPACK FOOTER //
// ./src/features/reports/components/single-client/form/table/SingleClientReportEntriesTable.jsx